import React from "react";
import * as Icon from "react-bootstrap-icons";
import * as Utils from "../../inc/Utils";
import {Link, NavLink} from "react-router-dom";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import Pagination from "react-js-pagination";
import {Config} from '../../Config'
import * as XLSX from "xlsx";
import * as AwsS3 from "../../inc/AwsS3";
import Select from 'react-select'
import DatePicker from "react-datepicker";
import {CopyToClipboard} from "react-copy-to-clipboard";
import ModalShortIO from "../utm/ModalShortIO";
import ModalQRCode from "../utm/ModalQRCode";

export default function GenerateMasterURL() {
    const roles = new Role();

    let btnTextDefault = 'ค้นหา';
    let btnTextLoading = 'กำลังค้นหา..';
    let [showSearch, setShowSearch] = React.useState(false);
    let [itemPerpage, setItemPerpage] = React.useState(10);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);
    let [startDate, setStartDate] = React.useState(null);
    let [endDate, setEndDate] = React.useState(null);
    let [userId, setUserId] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    let [showModalForm, setShowModalForm] = React.useState(false);
    let [showModalQRCode, setShowModalQRCode] = React.useState(false);
    let [isUpdateSlug, setIsUpdateSlug] = React.useState(false);
    let [shortIOData, setShortIOData] = React.useState(null);
    let [shortIOUrl, setShortIOUrl] = React.useState('');
    let [qrcodeLogo, setQrcodeLogo] = React.useState(null);
    let [awsS3Config, setAwsS3Config] = React.useState([]);

    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState(null);
    let [users, setUsers] = React.useState(null);
    let [param, setParam] = React.useState(null);

    const onSearch = (e) => {
        e.preventDefault();
        getDataSearch({
            param : e.target.elements.param.value,
            startDate : startDate ?? null,
            endDate : endDate ?? null,
            createdBy : userId != null ? userId.id : null,
            typeId : Utils.GENERATE_TYPE_MASTER_URL
        });
    };
    const onSearchReset = () => {
        setParam('');
        setUserId(null);
        setActivePage(0);
        getDataSearch({
            param : null,
            startDate : null,
            endDate : null,
            createdBy : null,
            typeId : Utils.GENERATE_TYPE_MASTER_URL,
            activePage: 1
        });
    };
    const onChangeUsers = (obj) => setUserId(obj);
    const onPageChange = (pageNum) => {
        setActivePage(pageNum);
        getDataSearch({
            param : param ?? null,
            startDate : startDate ?? null,
            endDate : endDate ?? null,
            createdBy : userId != null ? userId.id : null,
            typeId : Utils.GENERATE_TYPE_MASTER_URL,
            activePage: pageNum,
        });
    };

    React.useEffect(() => {
        (async function() {
            try {
                const resUsers = await getUsers();
                setUsers(resUsers);
                const resShortIO = await Utils.getShortio();
                setShortIO(resShortIO);

                const result = await getData({
                    startDate : null,
                    endDate : null,
                    createdBy: null,
                    typeId : Utils.GENERATE_TYPE_MASTER_URL
                });
                setCountAllItem(result.count);
                setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
                setData(result.rows);

                let resLogo = await Utils.getQrcodeLogo();
                setQrcodeLogo(resLogo);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, [isUpdateSlug]);

    async function getData(params) {
        setLoading(true);
        const response = await fetch(Config.url.API_URL +'/api/generate/listing', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                param : params.param ?? null,
                startDate : params.startDate ?? null,
                endDate : params.endDate ?? null,
                createdBy: params.createdBy ?? null,
                typeId : Utils.GENERATE_TYPE_MASTER_URL,
                itemPerpage: params.itemPerpage ?? itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
            })
        });

        setLoading(false);
        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getUsers() {
        const response = await fetch(Config.url.API_URL +'/api/user/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const getDataSearch = (params) => {
        setLoading(true);
        if(params.itemPerpage) {
            itemPerpage = params.itemPerpage;
        }
        fetch(Config.url.API_URL +'/api/generate/listing', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                param : params.param ?? null,
                startDate : params.startDate ?? null,
                endDate : params.endDate ?? null,
                createdBy: params.createdBy ?? null,
                typeId : Utils.GENERATE_TYPE_MASTER_URL,
                itemPerpage: itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
            })
        }).then(response => {
            setLoading(false);
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            setCountAllItem(result.count);
            setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
            setData(result.rows);
        }).catch(err => {
            toast.error(err.message);
        });
    };

    const onChangeParam = (value) => setParam(value);
    const onChangeItemPerpage = (e) => {
        setItemPerpage(e.target.value);
        setActivePage(1);
        getDataSearch({
            param : null,
            startDate : null,
            endDate: null,
            createdBy: null,
            typeId : Utils.GENERATE_TYPE_MASTER_URL,
            activePage: 1,
            itemPerpage: e.target.value
        });
    };
    const onChangeStartDate = (value) => {
        setStartDate(value);
        if(value > endDate) {
            setEndDate('');
        }
    };
    const onChangeEndDate = (value) => {
        setEndDate(value);
    };

    const onCopyFullUrl = () => {
        toast.success("คัดลอก Full URL แล้ว", {autoClose: 1000});
    };

    const onCopyRebrandlyUrl = () => {
        toast.success("คัดลอก Rebrandly Short URL แล้ว", {autoClose: 1000})
    };

    const onCopyShortIOUrl = () => {
        toast.success("คัดลอก Short URL แล้ว", {autoClose: 1000})
    };

    const onEditShortIO = (row) => {
        setShowModalForm(true);
        setShortIOData(row);
    };

    const handleModalFormUpdate = (flag) => {
        setIsUpdateSlug(flag);
    };

    const handleModalClose = () => {
        setShowModalForm(false);
        setShowModalQRCode(false);
        setShortIOData(null);
        getDataSearch({
            param : param ?? null,
            startDate : startDate ?? null,
            endDate : endDate ?? null,
            createdBy : userId != null ? userId.id : null,
            typeId : Utils.GENERATE_TYPE_MASTER_URL,
            activePage: activePage ?? 1,
        });
    };

    //QRCode
    const onShowQRCodeShortIO = async (shortUrl) => {
        const resAwsS3 = await AwsS3.getAwsS3();
        if(resAwsS3) {
            setAwsS3Config(resAwsS3);
            setShowModalForm(false);
            setShowModalQRCode(true);
            setShortIOUrl(shortUrl);
        }
    };
    //End

    const onExportSearch = async () => {
        if(!startDate) {
            toast.error("กรุณาระบุ Start Date");
        }
        else if(!endDate) {
            toast.error("กรุณาระบุ End Date");
        }
        else if(startDate > endDate) {
            toast.error("Start Date ต้องมากกว่า End Date");
        }
        else {
            let msDiff = new Date(endDate).getTime() - new Date(startDate).getTime();    //Future date - current date
            let dateDiff = Math.floor(msDiff / (1000 * 60 * 60 * 24));
            let leastDay = 1;
            if(dateDiff < leastDay) {
                toast.error("End Date ต้องห่างจาก Start Date อย่างน้อย " + leastDay + " วัน");
            }
            else {
                const result = await getData({
                    startDate : startDate,
                    endDate : endDate,
                    itemPerpage: 99999999999,
                    startItem: 1,
                    typeId : Utils.GENERATE_TYPE_MASTER_URL
                });
                if(result && result.count > 0) {
                    let jsonData = [];
                    result.rows.map(row => {

                        let utmUrl = '';
                        let campaignUrl = '';
                        let adssetUrl = '';
                        if(row.generateTypeUTM) {
                            utmUrl = row.url + '?' + row.paramsUTM + (row.addLine ? '#addline':'');
                        }
                        if(row.generateTypeCampaign) {
                            campaignUrl = row.paramsCampaign;
                        }
                        if(row.generateTypeAdsset) {
                            adssetUrl = row.paramsAdsset;
                        }

                        let objective = campaignUrl.split('|')[2];
                        let target_type = adssetUrl.split('|')[2];

                        jsonData.push({
                            Type: Utils.generateUTMType(row.typeId),
                            Lang: row.lang,
                            ProjectType: row.projectTypeId,
                            ProjectCode: row.projectId,
                            BuType: row.buTypeId,
                            CampaignType: row.campaignTypeId,
                            CampaignID: row.campaignId,
                            CampaignDate: row.campaignDate ? new Date(row.campaignDate) : '',
                            Objective: objective.split('_')[4],
                            TargetType: target_type.split('_')[0],
                            CampaignNaming: campaignUrl,
                            AdsetNaming: adssetUrl,
                            UTM: utmUrl,
                            REBRADLY_URL: row.shortUrl ?? '',
                            SHORT_IO_URL: row.shortioUrl && shortio.domain ? "https://" + shortio.domain + '/' + row.shortioUrl : '',
                            CREATED_BY: roles.loginName,
                            CREATED_DATE: Utils.dateYMDHI(new Date())
                        });
                    });
                    const worksheet = XLSX.utils.json_to_sheet(jsonData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "generate_masterurl_export_" + Utils.getDate() + ".xlsx");
                }
                else {
                    toast.error("ไม่พบข้อมูลตามที่ระบุไว้");
                }
            }
        }
    };

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Master URL</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                    {roles.isCreate(Utils.MENU_GENERATE_MASTER_URL) ? (
                        <NavLink className="btn btn-sm btn-primary" to='/generateMasterURL/create'><span><Icon.PlusLg/> Create Single</span></NavLink>
                    ) : ''}
                    {roles.isCreate(Utils.MENU_GENERATE_MASTER_URL) ? (
                        <NavLink className="btn btn-sm btn-primary ms-2" to='/generateMasterURL/createMultiple'><span><Icon.PlusLg/> Create Group</span></NavLink>
                    ) : ''}
                    {roles.isCreate(Utils.MENU_GENERATE_MASTER_URL) ? (
                        <NavLink className="btn btn-sm btn-success ms-2" to='/generateMasterURL/import'><span><Icon.FileExcel/> Import Excel</span></NavLink>
                    ) : ''}
                </div>
            </div>
            {isLoading ? (<span className="spinner-grow spinner-grow-sm"></span>) :
                <>
                    <div className="bg-light border rounded my-2">
                        <button type="button" className="btn btn-light w-100 text-start" onClick={() => {setShowSearch(!showSearch)}}><Icon.Search/> ค้นหา | เรียงลำดับ</button>
                        <div className={showSearch ? 'd-block p-3':'d-none'}>
                            <form className="row g-3" onSubmit={onSearch} onReset={onSearchReset}>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="param" className="form-label">UTM / Campaign / Ads Set</label>
                                    <input type="text" className="form-control" id="param" value={param ?? ''} onChange={(event) => onChangeParam(event.target.value)}  maxLength={100} />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="createdBy" className="form-label">Created By</label>
                                    <Select
                                        classNamePrefix="form-select-search"
                                        options={users}
                                        onChange={(event) => onChangeUsers(event)}
                                        defaultValue={userId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.contact}`}
                                    />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="name" className="form-label">Start Date</label>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={(date) => onChangeStartDate(date)}
                                        startDate={startDate}
                                        endDate={endDate}
                                        dateFormat="yyyy-MM-dd"
                                        wrapperClassName="w-100"
                                        className="form-control w-100" />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="name" className="form-label">End Date</label>
                                    <DatePicker
                                        selected={endDate}
                                        onChange={(date) => onChangeEndDate(date)}
                                        startDate={startDate}
                                        endDate={endDate}
                                        minDate={startDate}
                                        dateFormat="yyyy-MM-dd"
                                        wrapperClassName="w-100"
                                        className="form-control" />
                                </div>
                                <div className="col-12">
                                    <button type="submit" className="btn btn-primary">{isLoading ? btnTextLoading : btnTextDefault}</button>
                                    <button type="reset" className="btn btn-light border ms-2">รีเซ็ต</button>
                                    <button type="button" className="btn btn-success border ms-2" onClick={onExportSearch}><Icon.FileExcel/> Export File</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    {data === null || data.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                        <>
                            <div className="table-container shadow">
                                <div className="table-responsive">
                                    <table className="table table-striped">
                                        <thead>
                                        <tr>
                                            <th className="w50">ID</th>
                                            <th>Campaign URL</th>
                                            <th>Ads Set URL</th>
                                            <th>UTM URL</th>
                                            <th className="w80 text-center">Duplicate</th>
                                            <th className="text-center">Created By</th>
                                            <th className="text-center">Created Date</th>
                                            {roles.isDelete(Utils.MENU_GENERATE_PROJECT) ? (
                                                <th className="w70 text-center">ลบ</th>
                                            ) : ''}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data.map((row, index) => {
                                            let utmUrl = '';
                                            let campaignUrl = '';
                                            let adssetUrl = '';
                                            if(row.generateTypeUTM) {
                                                utmUrl = row.url + '?' + row.paramsUTM + (row.addLine ? '#addline':'');
                                            }
                                            if(row.generateTypeCampaign) {
                                                campaignUrl = row.paramsCampaign;
                                            }
                                            if(row.generateTypeAdsset) {
                                                adssetUrl = row.paramsAdsset;
                                            }
                                            return (
                                                <tr key={index} id={"rowId" + row.id}>
                                                    <td>{row.id}</td>
                                                    <td>
                                                        {
                                                            row.generateTypeCampaign ?
                                                                <><div className="noselect-url">{row.paramsCampaign}</div>
                                                                    <div className="mt-1">
                                                                        <CopyToClipboard text={campaignUrl} onCopy={() => {onCopyFullUrl()}}>
                                                                            <button type="button" className={campaignUrl ? 'btn btn-sm btn-light' : 'btn btn-sm btn-light d-none'} title="คัดลอก Full URL"><Icon.Files /></button>
                                                                        </CopyToClipboard>
                                                                    </div></> : ''
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            row.generateTypeAdsset ?
                                                                <><div className="noselect-url">{row.paramsAdsset}</div>
                                                                    <div className="mt-1">
                                                                        <CopyToClipboard text={adssetUrl} onCopy={() => {onCopyFullUrl()}}>
                                                                            <button type="button" className={adssetUrl ? 'btn btn-sm btn-light' : 'btn btn-sm btn-light d-none'} title="คัดลอก Full URL"><Icon.Files /></button>
                                                                        </CopyToClipboard>
                                                                    </div></> : ''
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            row.generateTypeUTM ?
                                                                <><div className="noselect-url">{utmUrl}</div>
                                                                    <div className="mt-1">
                                                                        <CopyToClipboard text={utmUrl} onCopy={() => {onCopyFullUrl()}}>
                                                                            <button type="button" className={utmUrl ? 'btn btn-sm btn-light' : 'btn btn-sm btn-light d-none'} title="คัดลอก Full URL"><Icon.Files /> Full URL</button>
                                                                        </CopyToClipboard>
                                                                        {
                                                                            row.shortUrl ? <CopyToClipboard text={"https://" + row.shortUrl} onCopy={() => {onCopyRebrandlyUrl()}}>
                                                                                <button type="button" className="btn btn-sm btn-light ms-1" title={"คัดลอก Short URL : " + row.shortUrl}>Rebrandly</button>
                                                                            </CopyToClipboard> : ''
                                                                        }
                                                                        {
                                                                            row.shortIO && shortio.domain ?
                                                                                <>
                                                                                    <CopyToClipboard text={"https://" + shortio.domain + '/' + row.shortIO} onCopy={() => {onCopyShortIOUrl()}}>
                                                                                        <button type="button" className="btn btn-sm btn-light ms-1" title={"คัดลอก Short URL : " + "https://" + shortio.domain + '/' + row.shortIO}><Icon.Files /> Short URL</button>
                                                                                    </CopyToClipboard>
                                                                                    {
                                                                                        roles.isEdit(Utils.MENU_SHORTIO) ? <button type="button" className="btn btn-sm btn-light ms-1" title={"แก้ไข Short URL : " + "https://" + shortio.domain + '/' + row.shortIO} onClick={ () => onEditShortIO(row)}><Icon.Pencil /></button> : ''
                                                                                    }
                                                                                    {
                                                                                        qrcodeLogo !== null && qrcodeLogo.length > 0 ? <button type="button" className="btn btn-sm btn-light ms-1" title="แสดง QR Code" onClick={ () => onShowQRCodeShortIO("https://" + shortio.domain + '/' + row.shortIO)}><Icon.QrCode /></button> : ''
                                                                                    }
                                                                                </>
                                                                                : ''
                                                                        }
                                                                    </div></> : ''
                                                        }
                                                    </td>
                                                    <td className="text-center">
                                                        {roles.isCreate(Utils.MENU_GENERATE_MASTER_URL) ? (
                                                            <Link className="btn btn-sm btn-light mx-1" to={'/generateMasterURL/duplicate/' + Utils.encodeItem({id: row.id,  createdAt: row.createdAt})}><Icon.Send/></Link>
                                                        ) : ''}
                                                    </td>
                                                    <td className="text-center small">{row.user && row.user.contact ? row.user.contact : ''}</td>
                                                    <td className="text-center">{Utils.dateTime(row.createdAt)}</td>
                                                    {roles.isDelete(Utils.MENU_GENERATE_MASTER_URL) ? (
                                                        <td className="text-center"><button className="btn btn-sm btn-light mx-1" onClick={() => Utils.deleteItem('generate', row.id, row.params)}><Icon.Trash/></button></td>
                                                    ) : ''}
                                                </tr>
                                            );
                                        })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 col-sm-4 mt-2 mt-sm-0 text-end align-self-center">
                                    <select className="form-select w100" id="itemPerpage" onChange={(e) => onChangeItemPerpage(e)} value={itemPerpage}>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                                <div className="col-12 col-sm-8">
                                    <div className={totalPage > 1 ? 'my-3':'d-none'}>
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            innerClass="pagination justify-content-sm-end"
                                            activePage={activePage}
                                            itemsCountPerPage={itemPerpage}
                                            totalItemsCount={countAllItem}
                                            pageRangeDisplayed={5}
                                            onChange={(pageNum) => onPageChange(pageNum)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {
                        showModalForm && <ModalShortIO data={shortIOData} handleModalClose={handleModalClose} handleModalFormUpdate={handleModalFormUpdate} />
                    }

                    {
                        showModalQRCode && <ModalQRCode shortIOUrl={shortIOUrl} qrcodeLogo={qrcodeLogo} awsS3Config={awsS3Config} handleModalClose={handleModalClose} />
                    }
                </>
            }
        </main>
    );
} 